import { Enum } from './Enum';

export class MemberPhoneDeletionReason extends Enum {
  translationKey = 'memberPhoneDeletionReason';

  static asArray: MemberPhoneDeletionReason[] = [];

  static byKey: { [name: string]: MemberPhoneDeletionReason } = {};

  static readonly ERROR = new MemberPhoneDeletionReason('ERROR');

  static readonly DUPLICATED = new MemberPhoneDeletionReason('DUPLICATED');

  static readonly WRONG = new MemberPhoneDeletionReason('WRONG');

  static readonly OTHER = new MemberPhoneDeletionReason('OTHER');

  constructor(public readonly value: string) {
    super();
    MemberPhoneDeletionReason.asArray.push(this);
    MemberPhoneDeletionReason.byKey[value] = this;
  }
}

export default MemberPhoneDeletionReason;
